import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    const token = localStorage.getItem("autorio_token");
    if (!token) {
      setAdmin(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
    } catch {
      localStorage.removeItem("autorio_token");
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("autorio_token", data.token);
    setAdmin({ email: data.email });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("autorio_token");
    setAdmin(null);
  };

  return (
    <AuthCtx.Provider value={{ admin, loading, login, logout, refresh: check }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth în afara AuthProvider");
  return ctx;
}
